<article class="container">
	<section class="modal-header">
		<p class="title">Editar perfil</p>
		<mat-icon
			svgIcon="pm-icons:close"
			style="width: 14px; height: 14px"
			(click)="closeModal()"
		></mat-icon>
	</section>
	<div class="modal-content">
		<form [formGroup]="userForm">
			<!-- Name -->
			<div class="form-field">
				<input
					type="text"
					id="name"
					class="form-field__input"
					formControlName="name"
					(focus)="getFieldState('name').setFocused(true)"
					(blur)="getFieldState('name').setFocused(false)"
					[ngClass]="{
						focused: getFieldState('name').focused(),
						filled: userForm.controls.name.value,
						editing: getFieldState('name').editing(),
						error: userForm.controls.name.errors && userForm.controls.name.dirty
					}"
				/>
				<label for="name" class="form-field__label">Nome</label>
				<span class="form-field__underline"></span>
				<div class="error-container">
					@if (userForm.controls.name.errors?.['required'] && userForm.controls.name.dirty) {
						<span class="error-message">Nome é obrigatório</span>
					}
				</div>
			</div>

			<!-- Email -->
			<div style="height: 24px"></div>
			<div class="form-field">
				<input
					type="text"
					id="email"
					class="form-field__input"
					formControlName="email"
					(focus)="getFieldState('email').setFocused(true)"
					(blur)="getFieldState('email').setFocused(false)"
					[ngClass]="{
						focused: getFieldState('email').focused(),
						filled: userForm.controls.email.value,
						editing: getFieldState('email').editing(),
						error: userForm.controls.email.errors && userForm.controls.email.dirty
					}"
				/>
				<label for="email" class="form-field__label">E-mail</label>
				<span class="form-field__underline"></span>
				<div class="error-container">
					@if (userForm.controls.email.errors?.['required'] && userForm.controls.email.dirty) {
						<span class="error-message">E-mail é obrigatório</span>
					} @else if (
						userForm.controls.email.errors?.['pattern'] && userForm.controls.email.dirty
					) {
						<span class="error-message">E-mail inválido</span>
					}
				</div>
			</div>

			<!-- Phone -->
			<div style="height: 24px"></div>
			<div class="form-field">
				<input
					type="text"
					id="phone"
					class="form-field__input"
					formControlName="phone"
					mask="+00 (00) 00000-0000"
					(focus)="getFieldState('phone').setFocused(true)"
					(blur)="getFieldState('phone').setFocused(false)"
					[ngClass]="{
						focused: getFieldState('phone').focused(),
						filled: userForm.controls.phone.value,
						editing: getFieldState('phone').editing(),
						error: userForm.controls.phone.errors && userForm.controls.phone.dirty
					}"
					mask="+00 (00) 00000-0000"
				/>
				<label for="phone" class="form-field__label">Telefone</label>
				<span class="form-field__underline"></span>
				<div class="error-container">
					@if (userForm.controls.phone.errors?.['required'] && userForm.controls.phone.dirty) {
						<span class="error-message">Telefone é obrigatório</span>
					} @else if (
						userForm.controls.phone.errors?.['pattern'] && userForm.controls.phone.dirty
					) {
						<span class="error-message">Telefone deve ter entre 10 e 11 dígitos</span>
					}
				</div>
			</div>

			<!-- CPF -->
			<div style="height: 24px"></div>
			<div class="form-field">
				<input
					type="text"
					id="cpf"
					class="form-field__input"
					formControlName="cpf"
					mask="000.000.000-00"
					(focus)="getFieldState('cpf').setFocused(true)"
					(blur)="getFieldState('cpf').setFocused(false)"
					[ngClass]="{
						focused: getFieldState('cpf').focused(),
						filled: userForm.controls.cpf.value,
						editing: getFieldState('cpf').editing(),
						error: userForm.controls.cpf.errors && userForm.controls.cpf.dirty
					}"
				/>
				<label for="cpf" class="form-field__label">CPF</label>
				<span class="form-field__underline"></span>
				<div class="error-container">
					@if (userForm.controls.cpf.errors?.['required'] && userForm.controls.cpf.dirty) {
						<span class="error-message">CPF é obrigatório</span>
					} @else if (userForm.controls.cpf.errors?.['invalidCpf'] && userForm.controls.cpf.dirty) {
						<span class="error-message">CPF inválido</span>
					}
				</div>
			</div>

			<div class="categories-section">
				<p class="categories-title">Cartões</p>

				<table mat-table class="categories-table" [dataSource]="allCards">
					<!-- Number Column -->
					<ng-container matColumnDef="number">
						<th mat-header-cell *matHeaderCellDef class="custom-column-title">Número</th>
						<td
							mat-cell
							*matCellDef="let categorie"
							[ngStyle]="{ color: categorie.isNew ? 'var(--content-primary)' : '' }"
						>
							{{ categorie.digits }}
						</td>
					</ng-container>

					<!-- Type Column -->
					<ng-container matColumnDef="type">
						<th mat-header-cell *matHeaderCellDef class="custom-column-title">Tipo</th>
						<td
							mat-cell
							*matCellDef="let categorie"
							[ngStyle]="{ color: categorie.isNew ? 'var(--content-primary)' : '' }"
						>
							{{ categorie.name }}
						</td>
					</ng-container>

					<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
					<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
				</table>

				<!-- NEW CARD FORM FIELD -->
				<mat-form-field appearance="outline" class="card-digits-field">
					<input
						#cardInput
						matInput
						placeholder="6 primeiros dígitos do cartão"
						maxlength="6"
						type="text"
						inputmode="numeric"
						pattern="\d*"
					/>
					<button
						mat-icon-button
						matSuffix
						(click)="addCard(cardInput.value); cardInput.value = ''"
					>
						<mat-icon
							svgIcon="pm-icons:plus"
							style="--icon-color-red: var(--content-primary)"
						></mat-icon>
					</button>
				</mat-form-field>
			</div>

			<!-- SAVE BUTTON -->
			@if (isLoading) {
				<ui-pm-loading-page style="--height: 50px" />
			} @else {
				<button
					mat-raised-button
					[color]="userForm.invalid || (!userForm.dirty && !isNewCardAdd()) ? '' : 'primary'"
					[disabled]="userForm.invalid || (!userForm.dirty && !isNewCardAdd())"
					style="margin-bottom: 24px"
					(click)="save()"
				>
					Salvar alterações
				</button>
			}
		</form>
	</div>
</article>
